import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Route } from 'react-router-dom';
import { PathData } from '../../hooks/UseData';
import { getLogger } from '../../utils/Logger';
import ListPage from './ListPage';
import Page from './Page';

const logger = getLogger(import.meta.url);

type ContainerProps = {
  basePath: string; // 共通のプレフィクス
  parentPath: string; // プレフィクス以下のパス構造
  paths: PathData;
};

const ReplaceCanonicalLink: React.FC = () => (
  <Helmet>
    <link
      rel="canonical"
      href={window.location.origin + window.location.pathname}
    />
  </Helmet>
);

const Container: React.FC<ContainerProps> = ({
  basePath, // 末尾は/
  parentPath, // 空文字、または末尾が/
  paths,
}) => {
  const routers: React.ReactElement[] = [];
  // 画面遷移のルーターを生成する。表示するページの要素ではない
  for (const [path, childPath] of Object.entries(paths)) {
    // path は aaa
    // childPath は /aaa/bbb
    if (typeof childPath === 'string') {
      // ページが指定された
      routers.push(
        <Route
          key={path}
          path={`${basePath}${parentPath}${path}`}
          render={() => {
            logger.debug(`START Route.render ${path} ${childPath}`);
            return (
              <>
                <ReplaceCanonicalLink />
                <Page filePath={childPath} />
              </>
            );
          }}
        />
      );
    } else {
      // コンテナが指定された
      routers.push(
        <Route
          key={path}
          path={`${basePath}${parentPath}${path}`}
          render={() => {
            logger.debug(`START Route.render ${path}`);
            return (
              <Container
                basePath={basePath}
                parentPath={`${parentPath}${path}/`}
                paths={childPath}
              />
            );
          }}
        />
      );
    }
  }
  // コンテナのパスと完全一致 (exact) するならリンクを表示
  // トップページは除く
  if (parentPath !== '') {
    routers.push(
      <Route
        exact
        key={parentPath}
        path={`${basePath}${parentPath}`}
        render={() => (
          <>
            <ReplaceCanonicalLink />
            <ListPage parentPath={parentPath} paths={Object.keys(paths)} />
          </>
        )}
      />
    );
  }
  return <>{routers}</>;
};

export default Container;
